module.exports = __webpack_public_path__ + "img/info_icon4.e55b9618.png";